import { Col, Row } from "antd";
import { NicheVerifyOtp } from "niche-ui-component";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useOrganization } from "../../OrganizationProvider";
import { setLoggedIn } from "../../reducers/authSlice";
import { ROUTES } from "../Common/Constants";
import { userGenerateJwtTokenUrl, userVerifyOtpUrl } from "../Common/endpoints";
import { setOrgDetails, setUserDetails } from "../Common/Utils";
import { MailOutlined } from "@ant-design/icons";
import { getApis } from "../Common/apis";

const VerifyOtp = () => {
  const phoneNumber = useSelector((state) => state?.auth?.phoneNumber);
  const organization = useOrganization();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const generateOrgToken = async (data) => {
    if (data?.organisations?.[1]?.id) {
      await getApis(
        userGenerateJwtTokenUrl,
        { orgId: data?.organisations?.[1].id },
        data?.authToken
      )
        .then((response) => {
          setOrgDetails(response?.data, data?.organisations?.[1]?.id);
        })
        .catch((e) => console.log(e.response?.data?.message));
      dispatch(setLoggedIn());
      navigate(ROUTES.DEFAULT.link);
    } else {
      // NO other orgs
      console.log("No Access to any Organization");
      dispatch(setLoggedIn());
      navigate(ROUTES.DEFAULT.link);
    }
  };

  const handleSubmit = (response) => {
    setUserDetails(response?.data);
    if (response?.data?.organisations?.[0]?.type === "ADMINISTRATOR") {
      generateOrgToken(response?.data);
    } else {
      dispatch(setLoggedIn());
      navigate(ROUTES.DEFAULT.link);
    }
  };

  return (
    <Row justify="center" className="mt1">
      <Col xs={24} sm={24} md={20} lg={20} xl={20}>
        <Row>
          <Col span={24}>
            <img
              src={`${organization.s3BucketBaseUrl}/OuterLogo.svg`}
              alt="Logo"
            />
          </Col>
        </Row>

        <Row className="mt2">
          <Col className="h1-header">Login with Mobile</Col>
        </Row>

        <Row className="mt2 mb2">
          <Col span={24}>
            <NicheVerifyOtp
              phoneNumber={phoneNumber}
              url={userVerifyOtpUrl}
              handleSubmit={handleSubmit}
            />
          </Col>
        </Row>
        <Row className="mt2 mb1 flex-center">
          <Col>
            <Link to="/login" title="Login via Email">
              <MailOutlined className="mr025" /> Login
            </Link>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default VerifyOtp;
